module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tjhzs-news tjhzs-main-content"
  }, [_c('header', [_c('h3', [_vm._v(_vm._s(_vm.hotel.name))])]), _vm._v(" "), _c('section', {
    staticClass: "img-group",
    style: (_vm.size)
  }, [_c('display-img', {
    attrs: {
      "isLink": false,
      "images": _vm.images,
      "size": _vm.size
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.getHtml(_vm.hotel.content))
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getHtml(_vm.hotel.content)) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "bottom-text"
  }, [_vm._v("全心全意服务糖酒会")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cb0b81e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Hotel.vue
// module id = 189
// module chunks = 1